import React, { useEffect, useState } from 'react';
import { Accordion, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getActiveHeader } from '../../redux/home/actions';
import SessionRequest from './home/SessionRequest';
import _ from 'lodash';
import { showLeftSession } from '../../utils/AppUtils';

const SideMenuFinwell = ({ isOpen, toggle}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation()
  // const activeHeaderItem = useSelector((state) => state.home.activeHeader);
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const [collapsed, setCollapsed] = React.useState(false);
  const [coachUrl, setCoachUrl] = React.useState("");
  const [activeHeaderItem, setActiveHeaderItem] = useState(sessionStorage.getItem('path') || 'home');
  const [accordionOpen, setAccordionOpen] = useState(false);

  useEffect(()=>{
    const path = location.pathname?.split('/')[1] || 'home'
    const menus = ['home', 'explore', 'assess', 'money-metric', 'calc','profile']
    const subMenus =['assess', 'money-metric', 'calc']
    if(menus.includes(path)){
      setActiveHeaderItem(path)
      sessionStorage.setItem('path',path)
    }
    const prevPath = sessionStorage.getItem('path')
    if(subMenus.includes(prevPath) ){
      setAccordionOpen(true)
    }
    if(window.location.pathname.includes("courseDetail")){
      setAccordionOpen(false)
    }
    
  },[location])

  useEffect(()=>{
    if(!toggle){
      setTimeout(() => {
        handleCollapse();
      }, 200);
    }
  },[toggle])

  React.useEffect(() => {
    if (collapsed) {
      document.body.classList.add('sidebar-collapsed');
    } else {
      document.body.classList.remove('sidebar-collapsed');
    }
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('sidebar-collapsed');
    };
  }, [collapsed]);

  const handleCollapse = () => {
    setCollapsed((prev) => !prev);
  };

  React.useEffect(() => {
    let userDetailResLocal = userDetailRes;
    console.log("userDetailResLocal", userDetailResLocal);
    if (!_.isEmpty(userDetailResLocal)) {
      if (userDetailResLocal?.status === "success") {
        let journey = userDetailResLocal?.payload?.payload?.money_journey;
        setCoachUrl(journey?.coach);

      }
    }
  }, [userDetailRes]);

  return (
    <aside id='idSideMenu'
      //className={`sidebar d-flex flex-column${collapsed ? ' collapsed' : ''}`} 
      className={`sidebar d-flex flex-column${collapsed ? ' collapsed' : ' not-collapse'} ${isOpen ? 'open' : ''}`}
      aria-label="Sidebar navigation">
      <Nav className="menu flex-column">
        {/* <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-home">Home</Tooltip>}
        >
          <Nav.Link onClick={() => { dispatch(getActiveHeader("home")); navigate("/home") }} className={activeHeaderItem === "home" ? "active" : ""} aria-current="page">
            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 -0.0078125L16 7.99219H13.504V14.0082H2.496V7.99219H0L8 -0.0078125ZM8 1.49619L2.496 7.00019H3.504V13.0002H12.496V7.00019H13.504L8 1.49619Z" fill="#474747" />
            </svg>
            <span className='navtext'>{!collapsed && 'Home'}</span>
          </Nav.Link>
        </OverlayTrigger> */}
{collapsed ? (
  <OverlayTrigger
    placement="right"
    overlay={<Tooltip id="tooltip-home">Home</Tooltip>}
  >
    <Nav.Link
      onClick={() => {
        dispatch(getActiveHeader("home"));
        navigate("/home");
      }}
      className={activeHeaderItem === "home" ? "active" : ""}
      aria-current="page"
    >
      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 -0.0078125L16 7.99219H13.504V14.0082H2.496V7.99219H0L8 -0.0078125ZM8 1.49619L2.496 7.00019H3.504V13.0002H12.496V7.00019H13.504L8 1.49619Z" fill="#474747" />
      </svg>
    </Nav.Link>
  </OverlayTrigger>
) : (
  <Nav.Link
    onClick={() => {
      dispatch(getActiveHeader("home"));
      navigate("/home");
    }}
    className={activeHeaderItem === "home" ? "active" : ""}
    aria-current="page"
  >
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 -0.0078125L16 7.99219H13.504V14.0082H2.496V7.99219H0L8 -0.0078125ZM8 1.49619L2.496 7.00019H3.504V13.0002H12.496V7.00019H13.504L8 1.49619Z" fill="#474747" />
    </svg>
    <span className="navtext">Home</span>
  </Nav.Link>
)}

   {collapsed ? (
  <OverlayTrigger
    placement="right"
    overlay={<Tooltip id="tooltip-explore">Explore</Tooltip>}
  >
    <Nav.Link
      onClick={() => {
        dispatch(getActiveHeader("explore"));
        navigate("/explore?pillar_id=all");
      }}
      className={activeHeaderItem === "explore" ? "active" : ""}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.736 9.472L6.56 7.296L5.84 10.192L8.736 9.472ZM7.264 6.592L9.44 8.752L10.16 5.872L7.264 6.592ZM8 0C9.07733 0 10.112 0.208 11.104 0.624C12.064 1.04 12.912 1.616 13.648 2.352C14.384 3.088 14.96 3.936 15.376 4.896C15.792 5.888 16 6.92267 16 8C16 9.07733 15.792 10.112 15.376 11.104C14.96 12.064 14.384 12.912 13.648 13.648C12.912 14.384 12.064 14.96 11.104 15.376C10.112 15.792 9.07733 16 8 16C6.92267 16 5.888 15.792 4.896 15.376C3.936 14.96 3.088 14.384 2.352 13.648C1.616 12.912 1.04 12.064 0.624 11.104C0.208 10.112 0 9.07733 0 8C0 6.92267 0.208 5.888 0.624 4.896C1.04 3.936 1.616 3.088 2.352 2.352C3.088 1.616 3.936 1.04 4.896 0.624C5.888 0.208 6.92267 0 8 0ZM8.496 14.944C9.62667 14.88 10.6827 14.5493 11.664 13.952C12.6133 13.376 13.376 12.6133 13.952 11.664C14.5493 10.6827 14.88 9.62667 14.944 8.496H13.504C13.3547 8.496 13.232 8.45333 13.136 8.368C13.0507 8.272 13.008 8.14933 13.008 8C13.008 7.85067 13.0507 7.73333 13.136 7.648C13.232 7.552 13.3547 7.504 13.504 7.504H14.944C14.88 6.37333 14.5493 5.32267 13.952 4.352C13.376 3.41333 12.6133 2.65067 11.664 2.064C10.6933 1.46667 9.63733 1.13067 8.496 1.056V2.496C8.496 2.64533 8.448 2.768 8.352 2.864C8.26667 2.94933 8.14933 2.992 8 2.992C7.85067 2.992 7.728 2.94933 7.632 2.864C7.54667 2.768 7.504 2.64533 7.504 2.496V1.056C6.37333 1.12 5.31733 1.45067 4.336 2.048C3.38667 2.624 2.624 3.38667 2.048 4.336C1.45067 5.31733 1.12 6.37333 1.056 7.504H2.496C2.64533 7.504 2.768 7.552 2.864 7.648C2.96 7.73333 3.008 7.85067 3.008 8C3.008 8.14933 2.96 8.272 2.864 8.368C2.768 8.45333 2.64533 8.496 2.496 8.496H1.056C1.12 9.62667 1.45067 10.6827 2.048 11.664C2.624 12.6133 3.38667 13.376 4.336 13.952C5.31733 14.5493 6.37333 14.88 7.504 14.944V13.504C7.504 13.3547 7.54667 13.232 7.632 13.136C7.728 13.04 7.85067 12.992 8 12.992C8.14933 12.992 8.26667 13.04 8.352 13.136C8.448 13.232 8.496 13.3547 8.496 13.504V14.944ZM9.536 10.288L5.28 11.36C5.14133 11.392 5.01333 11.376 4.896 11.312C4.77867 11.2373 4.704 11.1307 4.672 10.992C4.64 10.9067 4.64 10.8267 4.672 10.752L5.728 6.496C5.78133 6.31467 5.872 6.16 6 6.032C6.128 5.89333 6.28267 5.80267 6.464 5.76L10.72 4.688C10.8587 4.656 10.9867 4.67733 11.104 4.752C11.2213 4.816 11.296 4.91733 11.328 5.056C11.36 5.13067 11.36 5.21067 11.328 5.296L10.272 9.568C10.2187 9.74933 10.128 9.904 10 10.032C9.872 10.16 9.71733 10.2453 9.536 10.288Z" fill="#474747" />
            </svg>
    </Nav.Link>
  </OverlayTrigger>
) : (
  <Nav.Link
    onClick={() => {
      dispatch(getActiveHeader("explore"));
      navigate("/explore?pillar_id=all");
    }}
    className={activeHeaderItem === "explore" ? "active" : ""}
  >
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.736 9.472L6.56 7.296L5.84 10.192L8.736 9.472ZM7.264 6.592L9.44 8.752L10.16 5.872L7.264 6.592ZM8 0C9.07733 0 10.112 0.208 11.104 0.624C12.064 1.04 12.912 1.616 13.648 2.352C14.384 3.088 14.96 3.936 15.376 4.896C15.792 5.888 16 6.92267 16 8C16 9.07733 15.792 10.112 15.376 11.104C14.96 12.064 14.384 12.912 13.648 13.648C12.912 14.384 12.064 14.96 11.104 15.376C10.112 15.792 9.07733 16 8 16C6.92267 16 5.888 15.792 4.896 15.376C3.936 14.96 3.088 14.384 2.352 13.648C1.616 12.912 1.04 12.064 0.624 11.104C0.208 10.112 0 9.07733 0 8C0 6.92267 0.208 5.888 0.624 4.896C1.04 3.936 1.616 3.088 2.352 2.352C3.088 1.616 3.936 1.04 4.896 0.624C5.888 0.208 6.92267 0 8 0ZM8.496 14.944C9.62667 14.88 10.6827 14.5493 11.664 13.952C12.6133 13.376 13.376 12.6133 13.952 11.664C14.5493 10.6827 14.88 9.62667 14.944 8.496H13.504C13.3547 8.496 13.232 8.45333 13.136 8.368C13.0507 8.272 13.008 8.14933 13.008 8C13.008 7.85067 13.0507 7.73333 13.136 7.648C13.232 7.552 13.3547 7.504 13.504 7.504H14.944C14.88 6.37333 14.5493 5.32267 13.952 4.352C13.376 3.41333 12.6133 2.65067 11.664 2.064C10.6933 1.46667 9.63733 1.13067 8.496 1.056V2.496C8.496 2.64533 8.448 2.768 8.352 2.864C8.26667 2.94933 8.14933 2.992 8 2.992C7.85067 2.992 7.728 2.94933 7.632 2.864C7.54667 2.768 7.504 2.64533 7.504 2.496V1.056C6.37333 1.12 5.31733 1.45067 4.336 2.048C3.38667 2.624 2.624 3.38667 2.048 4.336C1.45067 5.31733 1.12 6.37333 1.056 7.504H2.496C2.64533 7.504 2.768 7.552 2.864 7.648C2.96 7.73333 3.008 7.85067 3.008 8C3.008 8.14933 2.96 8.272 2.864 8.368C2.768 8.45333 2.64533 8.496 2.496 8.496H1.056C1.12 9.62667 1.45067 10.6827 2.048 11.664C2.624 12.6133 3.38667 13.376 4.336 13.952C5.31733 14.5493 6.37333 14.88 7.504 14.944V13.504C7.504 13.3547 7.54667 13.232 7.632 13.136C7.728 13.04 7.85067 12.992 8 12.992C8.14933 12.992 8.26667 13.04 8.352 13.136C8.448 13.232 8.496 13.3547 8.496 13.504V14.944ZM9.536 10.288L5.28 11.36C5.14133 11.392 5.01333 11.376 4.896 11.312C4.77867 11.2373 4.704 11.1307 4.672 10.992C4.64 10.9067 4.64 10.8267 4.672 10.752L5.728 6.496C5.78133 6.31467 5.872 6.16 6 6.032C6.128 5.89333 6.28267 5.80267 6.464 5.76L10.72 4.688C10.8587 4.656 10.9867 4.67733 11.104 4.752C11.2213 4.816 11.296 4.91733 11.328 5.056C11.36 5.13067 11.36 5.21067 11.328 5.296L10.272 9.568C10.2187 9.74933 10.128 9.904 10 10.032C9.872 10.16 9.71733 10.2453 9.536 10.288Z" fill="#474747" />
            </svg>
    <span className="navtext"> Explore</span>
  </Nav.Link>
)}


        <Accordion
          flush
          activeKey={accordionOpen ? "0" : null}
          onClick={() => setAccordionOpen(!accordionOpen)}
        >
          <Accordion.Item eventKey="0">
            {collapsed ? (
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-assess">Assess</Tooltip>}
              >
                <Accordion.Header
                  className={
                    ["calc", "money-metric", "assess"].includes(activeHeaderItem)
                      ? "active"
                      : ""
                  }
                >
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.5 1C13.0533 1 13.5 1.44889 13.5 2V15C13.5 15.5511 13.0533 16 12.5 16H1.5C0.948889 16 0.5 15.5511 0.5 15V2C0.5 1.44889 0.948889 1 1.5 1H3V2H1.5V15H12.5V2H11V1H12.5ZM4 1V0H10V1H4ZM10.5022 6.66222L9.79333 5.95556L5.80222 9.96222L4.20444 8.36444L3.49778 9.07111L5.80444 11.3778L10.5044 6.66222H10.5022Z"
                      fill="#474747"
                    />
                  </svg>
                </Accordion.Header>
              </OverlayTrigger>
            ) : (
              <Accordion.Header
                className={
                  ["calc", "money-metric", "assess"].includes(activeHeaderItem)
                    ? "active"
                    : ""
                }
              >
                <svg
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5 1C13.0533 1 13.5 1.44889 13.5 2V15C13.5 15.5511 13.0533 16 12.5 16H1.5C0.948889 16 0.5 15.5511 0.5 15V2C0.5 1.44889 0.948889 1 1.5 1H3V2H1.5V15H12.5V2H11V1H12.5ZM4 1V0H10V1H4ZM10.5022 6.66222L9.79333 5.95556L5.80222 9.96222L4.20444 8.36444L3.49778 9.07111L5.80444 11.3778L10.5044 6.66222H10.5022Z"
                    fill="#474747"
                  />
                </svg>
                <span className="navtext"> Assess</span>
              </Accordion.Header>
            )}
            <Accordion.Body className="p-0">
              <Nav className="flex-column nav-subbar gap-1">
                <Nav.Link
                  onClick={() => {
                    dispatch(getActiveHeader("calc"));
                    navigate("/calc");
                  }}
                  className={activeHeaderItem === "calc" ? "active" : ""}
                >
                  Calculators
                </Nav.Link>
                <Nav.Link
                  onClick={() => {
                    dispatch(getActiveHeader("money"));
                    navigate("/money-metric");
                  }}
                  className={activeHeaderItem === "money-metric" ? "active" : ""}
                >
                  Money Metrics
                </Nav.Link>
                <Nav.Link
                  onClick={() => {
                    dispatch(getActiveHeader("assess"));
                    navigate("/assess");
                  }}
                  className={activeHeaderItem === "assess" ? "active" : ""}
                >
                  Assessments
                </Nav.Link>
              </Nav>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

      </Nav>
      <div className='sidebar-footer d-flex flex-column gap-3'>
        {showLeftSession()&&<>
          {collapsed ? (
            <Nav className="menu flex-column">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-home">Get started with a coach</Tooltip>}
              >
                <Nav.Link className="active" aria-current="page">
                  <svg width="20" height="20" viewBox="0 0 30 48" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15 25.5C13.5 25.5 12.12 25.13 10.86 24.39C9.60001 23.63 8.60001 22.62 7.86 21.36C7.12001 20.1 6.75 18.73 6.75 17.25C6.75 15.75 7.12001 14.37 7.86 13.11C8.60001 11.85 9.60001 10.85 10.86 10.11C12.12 9.37 13.5 9 15 9C16.5 9 17.88 9.37 19.14 10.11C20.4 10.85 21.4 11.85 22.14 13.11C22.88 14.37 23.25 15.75 23.25 17.25C23.25 18.75 22.88 20.13 22.14 21.39C21.4 22.65 20.4 23.65 19.14 24.39C17.88 25.13 16.5 25.5 15 25.5ZM15 10.83C13.84 10.83 12.77 11.12 11.79 11.7C10.81 12.28 10.03 13.06 9.45001 14.04C8.89001 15.02 8.61001 16.09 8.61001 17.25C8.61001 18.41 8.89001 19.48 9.45001 20.46C10.03 21.44 10.81 22.22 11.79 22.8C12.77 23.36 13.84 23.64 15 23.64C16.16 23.64 17.23 23.36 18.21 22.8C19.19 22.22 19.96 21.44 20.52 20.46C21.1 19.48 21.39 18.41 21.39 17.25C21.39 16.09 21.1 15.02 20.52 14.04C19.96 13.06 19.19 12.28 18.21 11.7C17.23 11.12 16.16 10.83 15 10.83ZM27.3 29.16C27.46 29.24 27.59 29.36 27.69 29.52C27.81 29.66 27.87 29.82 27.87 30V38.07C27.87 38.33 27.78 38.55 27.6 38.73C27.42 38.91 27.2 39 26.94 39H3.06C2.8 39 2.58 38.91 2.4 38.73C2.22 38.55 2.13 38.33 2.13 38.07V30C2.13 29.82 2.18 29.66 2.28 29.52C2.38 29.36 2.52 29.24 2.7 29.16C5.08 28.12 7.74001 27.41 10.68 27.03C13.56 26.67 16.44 26.67 19.32 27.03C22.26 27.41 24.92 28.12 27.3 29.16ZM15 30.9L14.04 34.17L14.94 35.1L15.96 34.14L15 30.9ZM26.01 37.17V30.63C23.37 29.59 20.62 28.96 17.76 28.74L16.14 29.28L17.97 34.26C18.05 34.48 18.04 34.7 17.94 34.92C17.86 35.14 17.72 35.3 17.52 35.4L14.88 37.38L12.42 35.37C12.22 35.27 12.08 35.11 12 34.89C11.94 34.69 11.95 34.48 12.03 34.26L13.86 29.28L12.24 28.74C9.38 28.96 6.63 29.59 3.99 30.63V37.17H26.01Z"
                      fill="#474747"></path>
                  </svg>
                </Nav.Link>
              </OverlayTrigger>

            </Nav>

          ) : (
            <SessionRequest from="left" coach={coachUrl} />
          )}
        </>}
        <div
          className="collapsebtn d-flex align-items-center gap-2"
          onClick={handleCollapse}
          style={{ cursor: 'pointer' }}
          tabindex="0"
          aria-label="Collapse SideBar"
        >
          {/* Show left arrow when expanded, right arrow when collapsed */}
          {collapsed ? (
            // ▶️ Right arrow (expand)
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.92834 4.624L5.63234 3.92L9.72834 8L5.63234 12.08L4.92834 11.376L7.80834 8.496H0.944336V7.504H7.80834L4.92834 4.624ZM10.3843 2H15.0563V14H10.3843V2ZM2.06434 0.992V3.504H1.05634V0.992C1.05634 0.714667 1.15234 0.48 1.34434 0.288C1.547 0.096 1.787 0 2.06434 0H16.0643C16.3417 0 16.5763 0.096 16.7683 0.288C16.9603 0.48 17.0563 0.714667 17.0563 0.992V15.008C17.0563 15.2747 16.9603 15.504 16.7683 15.696C16.5763 15.8987 16.3417 16 16.0643 16H2.06434C1.787 16 1.547 15.904 1.34434 15.712C1.15234 15.52 1.05634 15.2853 1.05634 15.008V12.496H2.06434V15.008H16.0643V0.992H2.06434Z" fill="#474747" />
            </svg>
          ) : (
            // ◀️ Left arrow (collapse)
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.016 11.376L11.312 12.08L7.232 8L11.312 3.92L12.016 4.624L9.136 7.504H16V8.496H9.136L12.016 11.376ZM2 2H6.672V14H2V2ZM15.008 15.008V12.496H16V15.008C16 15.2747 15.904 15.504 15.712 15.696C15.52 15.8987 15.2853 16 15.008 16H1.008C0.730667 16 0.490667 15.904 0.288 15.712C0.096 15.52 0 15.2853 0 15.008V0.992C0 0.714667 0.096 0.48 0.288 0.288C0.490667 0.096 0.730667 0 1.008 0H15.008C15.2853 0 15.52 0.096 15.712 0.288C15.904 0.48 16 0.714667 16 0.992V3.504H15.008V0.992H1.008V15.008H15.008Z" fill="#474747" />
            </svg>
          )}

          <span className="navtext">{!collapsed && 'Collapse'}</span>
        </div>
      </div>
    </aside>
  );
};

export default SideMenuFinwell;